import { getIconByLabel } from '../../../helper/prospect_helper';
import { gray } from '../../../theme/themePrimitives';
import { MetaObject } from '../../../params/prospect';
import { Box, Tooltip } from '@mui/material';

interface RenderIconsParams {
    contacts: MetaObject[];
}

const RenderIcons: React.FC<RenderIconsParams> = ({ contacts }: RenderIconsParams) => (
    <Box display="flex" gap={1}
        sx={{
            'overflowY': 'hidden',
            'overflowX': 'auto',
            'scrollbarWidth': '1px',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            'paddingBottom': '4px',
            'maxWidth': '100%'
        }}
    >
        {contacts.map((contact: MetaObject) => {
            const icon = getIconByLabel(contact.meta_key);
            return (
                icon && (
                    <Box
                        key={contact.id || contact.meta_key}
                        border="1px solid"
                        borderColor={gray[400]}
                        margin="12px 0"
                        borderRadius="6px"
                        padding="3px 3px"
                        display="flex"
                        alignContent="center"
                        justifyContent="center"
                    >
                        <Tooltip title={`${contact.meta_key}: ${contact.meta_value}`}>
                            <Box component="span" sx={{ color: gray[400] }} display="flex" alignItems="center" justifyContent="center">{icon}</Box>
                        </Tooltip></Box>
                )
            );
        })}
    </Box>
);

export default RenderIcons;